export const MENU_MAIN_SELECTOR = 1;
export const MENU_FILES = 2;
export const MENU_ROLES = 3;
export const MENU_GLOBAL_GRID = 4;
export const MENU_GRID_TABS = 5;
export const MENU_GRID_RENDER = 6;
export const MENU_EXCLUSIONS = 7;
